// Sales widget helper functions and data
import { widgetInitialData } from "../widgets.helpers";
import { ServiceDrawers } from "./widgets.service.types";

const drawers: ServiceDrawers = {
  assignee: {
    visible: false
  },
  editTicket: {
    visible: false
  },
  newTicket: {
    visible: false
  }
};

export const serviceInitialData = { ...widgetInitialData, drawers };
